import { getGlobal, setGlobalIfNone } from '../helpers/globals';
setGlobalIfNone("JDWSV_URL_PREFIX", "//jdwsv.jd.com");
var URL_PREFIX = getGlobal("JDWSV_URL_PREFIX");
// 商品组查询
export var PRODUCT_QUERY = URL_PREFIX + "/v1/material/queryProducts";
// 广告组查询
export var ADV_QUERY = URL_PREFIX + "/v1/material/queryAdvs";
// 领取优惠券
export var COUPON_GET = URL_PREFIX + "/v1/coupon/get";
